module.exports = __webpack_public_path__ + "static/media/2017_conf_A_Playbook_for_Achieving_Product_Market_Fit.369cb346.png";